import { jsx as _jsx } from "react/jsx-runtime";
import LeadsWorkspace from 'components/LeadsWorkspace';
import { useWorkspace } from 'features/workspace/context';
export default function LeadsRoute() {
    const { quickLinks } = useWorkspace();
    const links = quickLinks.filter((link) => link.category === 'leads' || link.category === 'dashboard');
    return _jsx(LeadsWorkspace, { embedded: true, links: links });
}
